import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import TrialBanner from "./TrialBanner";
import { useAuth } from "@/lib/auth";

export default function DashboardLayout() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F9F8F6]">
        <div className="animate-pulse text-[#5E5E5E]">Loading…</div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  return (
    <div className="flex min-h-screen bg-[#F9F8F6]">
      <Sidebar />
      <main className="flex-1 min-h-screen">
        <TrialBanner />
        <div className="max-w-[1400px] mx-auto px-8 py-10">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
